import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

const BASE = `${config.API_URL}Beacon4PerformanceNetworkOverview/admin`;

// ── KPI Configs ─────────────────────────────────────────────────────────────
export const ListBeacon4PerfConfigs = (params) =>
	AxiosRequest({ method: 'GET', url: `${BASE}/kpis`, params });

export const GetBeacon4PerfConfig = (id) =>
	AxiosRequest({ method: 'GET', url: `${BASE}/kpis/${id}` });

export const CreateBeacon4PerfConfig = (data) =>
	AxiosRequest({ method: 'POST', url: `${BASE}/kpis`, data });

export const UpdateBeacon4PerfConfig = (id, data) =>
	AxiosRequest({ method: 'PUT', url: `${BASE}/kpis/${id}`, data });

export const DeleteBeacon4PerfConfig = (id, note) =>
	AxiosRequest({ method: 'DELETE', url: `${BASE}/kpis/${id}`, params: { note } });

export const ValidateBeacon4PerfSql = (data) =>
	AxiosRequest({ method: 'POST', url: `${BASE}/kpis/validate-sql`, data });

// ── Source catalog ──────────────────────────────────────────────────────────
// Curated allowlist of views the Formula tab may author against, so users no
// longer need direct SQL Server access to know what exists.
export const ListBeacon4PerfCatalog = (tech) =>
	AxiosRequest({ method: 'GET', url: `${BASE}/catalog`, params: { tech } });

// Keyed by catalog id, never by view name — the server resolves the name.
export const ListBeacon4PerfCatalogColumns = (id) =>
	AxiosRequest({ method: 'GET', url: `${BASE}/catalog/${id}/columns` });

// Served from the validator's own allowlist so the palette can't drift from it.
export const ListBeacon4PerfSqlFunctions = () =>
	AxiosRequest({ method: 'GET', url: `${BASE}/sql-functions` });

// ── Mappings ────────────────────────────────────────────────────────────────
export const ListBeacon4PerfMappings = (mainKpiId) =>
	AxiosRequest({ method: 'GET', url: `${BASE}/mappings`, params: { mainKpiId } });

export const CreateBeacon4PerfMapping = (data) =>
	AxiosRequest({ method: 'POST', url: `${BASE}/mappings`, data });

export const UpdateBeacon4PerfMapping = (id, data) =>
	AxiosRequest({ method: 'PUT', url: `${BASE}/mappings/${id}`, data });

export const DeleteBeacon4PerfMapping = (id, note) =>
	AxiosRequest({ method: 'DELETE', url: `${BASE}/mappings/${id}`, params: { note } });

// ── Audit ───────────────────────────────────────────────────────────────────
export const ListBeacon4PerfAudit = (table, id) =>
	AxiosRequest({ method: 'GET', url: `${BASE}/audit/${table}/${id}` });

export const RollbackBeacon4PerfAudit = (auditId, note) =>
	AxiosRequest({ method: 'POST', url: `${BASE}/audit/${auditId}/rollback`, data: { note } });
